import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "w-full"
};
const _hoisted_2 = { class: "px-16 mb-16 items-list" };
const _hoisted_3 = { key: "new" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    name: 'ActionItems',
    ...componentI18n('components.action_items')
};
import { storeToRefs } from 'pinia';
import NewActionItem from '@/components/action_items/NewActionItem.vue';
import NewActionItemCard from '@/components/action_items/NewActionItemCard.vue';
import NewActionItemEmptyState from '@/components/action_items/NewActionItemEmptyState.vue';
import EditActionItem from '@/components/action_items/EditActionItem.vue';
import NewActionItemByOther from '@/components/action_items/NewActionItemByOther.vue';
import EditActionItemByOther from '@/components/action_items/EditActionItemByOther.vue';
import ActionItem from '@/components/action_items/ActionItem.vue';
import { useRetroStore } from '@/pinia_stores/retro';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        groupId: { type: Number, default: null },
        items: { type: Array, required: true },
        showHeading: { type: Boolean, default: false }
    },
    setup(__props) {
        const retroStore = useRetroStore();
        const { isModerator, isParticipant, actionItemBeingEdited, phase, isCurrentUserWritingActionItem, isActionItemWritingIdle, isActionItemBeingEdited, isOtherUserWritingActionItem, isNewActionItemBeingWritten } = storeToRefs(retroStore);
        return (_ctx, _cache) => {
            const _component_inner_heading = _resolveComponent("inner-heading");
            return ((_unref(phase) === 'discussion' || _unref(phase) === 'review') &&
                (_unref(isModerator) || _unref(isParticipant)) &&
                __props.items.length == 0 &&
                _unref(isActionItemWritingIdle))
                ? (_openBlock(), _createBlock(NewActionItemEmptyState, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (__props.showHeading)
                        ? (_openBlock(), _createBlock(_component_inner_heading, {
                            key: 0,
                            heading: _ctx.$t('action_items')
                        }, null, 8, ["heading"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: item.id
                            }, [
                                (_unref(isActionItemBeingEdited) &&
                                    _unref(isCurrentUserWritingActionItem) &&
                                    item.id === _unref(actionItemBeingEdited).id)
                                    ? (_openBlock(), _createBlock(EditActionItem, {
                                        key: 0,
                                        item: item
                                    }, null, 8, ["item"]))
                                    : (_unref(isActionItemBeingEdited) &&
                                        _unref(isOtherUserWritingActionItem) &&
                                        item.id === _unref(actionItemBeingEdited).id)
                                        ? (_openBlock(), _createBlock(EditActionItemByOther, {
                                            key: 1,
                                            item: item
                                        }, null, 8, ["item"]))
                                        : (_openBlock(), _createBlock(ActionItem, {
                                            key: 2,
                                            item: item
                                        }, null, 8, ["item"]))
                            ]));
                        }), 128)),
                        (_unref(phase) === 'discussion' || _unref(phase) === 'review')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                                (_unref(isActionItemWritingIdle))
                                    ? (_openBlock(), _createBlock(NewActionItemCard, { key: 0 }))
                                    : (_unref(isNewActionItemBeingWritten) && _unref(isCurrentUserWritingActionItem))
                                        ? (_openBlock(), _createBlock(NewActionItem, {
                                            key: 1,
                                            "group-id": __props.groupId
                                        }, null, 8, ["group-id"]))
                                        : (_unref(isNewActionItemBeingWritten) && _unref(isOtherUserWritingActionItem))
                                            ? (_openBlock(), _createBlock(NewActionItemByOther, {
                                                key: 2,
                                                "group-id": __props.groupId
                                            }, null, 8, ["group-id"]))
                                            : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]));
        };
    }
});
